// AUTO-GENERATED GraphQL Builder for State
import * as Builders from '../';
export class StateBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  countryId(){ return this.add('countryId'); }
  code(){ return this.add('code'); }
  name(){ return this.add('name'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  country(b?:(q:Builders.CountryBuilder)=>void){
    if(this.depth>=5||this.v.has('country'))return this;
    this.v.add('country');
    const n=new Builders.CountryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`country { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  cityList(b?:(q:Builders.CityBuilder)=>void){
    if(this.depth>=5||this.v.has('cityList'))return this;
    this.v.add('cityList');
    const n=new Builders.CityBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`cityList { ${inner} }`);
    return this;
  }

  vendorList(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('vendorList'))return this;
    this.v.add('vendorList');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorList { ${inner} }`);
    return this;
  }

  vendorCoverageAreaList(b?:(q:Builders.VendorCoverageAreaBuilder)=>void){
    if(this.depth>=5||this.v.has('vendorCoverageAreaList'))return this;
    this.v.add('vendorCoverageAreaList');
    const n=new Builders.VendorCoverageAreaBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorCoverageAreaList { ${inner} }`);
    return this;
  }

  reverseCity(b?:(q:Builders.CityBuilder)=>void){
    const n=new Builders.CityBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`cityList { ${inner} }`);
    return this;
  }

  reverseVendorCoverageArea(b?:(q:Builders.VendorCoverageAreaBuilder)=>void){
    const n=new Builders.VendorCoverageAreaBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorCoverageAreaList { ${inner} }`);
    return this;
  }

  reverseVendor(b?:(q:Builders.VendorBuilder)=>void){
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorList { ${inner} }`);
    return this;
  }
}
